import img from "../Images/aboutus-img.png";

const tieFeatures = {
    featureTitle :"Our Core",
    title_s:"Services",
    featureDescription:"We provide cutting-edge software solutions, from development to modernization, empowering businesses with innovation and efficiency.",
    featureLists : [
        {
          title: "🚀 Software Development",
          description: "We design and develop custom software solutions that streamline workflows, automate tasks, and improve operational efficiency."
        },
        {
          title: "💡 Software Product Development",
          description: "From idea to deployment, we build scalable and market-ready software products, ensuring a seamless user experience and business growth."
        },
        {
          title: "🔄 Application Modernization",
          description: "We help businesses upgrade and migrate legacy applications to modern, cloud-based, and high-performance systems, improving security and efficiency."
        },
        {
          title: "🌐 IoT Services and Consulting",
          description: "Quickly download and print e-way bills for documentation and verification."
        },
        {
          title: "🌐 IoT Services and Consulting",
          description: "Our IoT solutions empower industries with real-time data, smart automation, and device connectivity, driving innovation and efficiency."
        },
        {
          title: "📱 Mobile App Development",
          description: "We create high-performance mobile apps for Android, iOS, and cross-platform environments, ensuring superior user engagement and business reach."
        },
        {
          title: "🖥 Web Development",
          description: "From dynamic websites to enterprise-grade web applications, we build secure, fast, and user-friendly web solutions for businesses."
        },
        {
          title: "⚙ DevOps",
          description: "We enhance software development, deployment, and maintenance with CI/CD integration, cloud automation, and continuous monitoring, improving performance and scalability."
        },
       
      ]
}
  

const chooseTie = {
    title:"Why Choose",
    title_h:"Tech It Easy?",
    description:"We deliver innovative, scalable, and secure technology solutions tailored to drive business growth and efficiency.",
     lists: [
      {
        title: "Expertise Across Industries",
        description: "Proven solutions in logistics, enterprise, and digital transformation."
      },
      {
        title: "Scalable & Secure Solutions",
        description: "Future-proof applications designed for growth and efficiency."
      },
      {
        title: "Customer-Centric Approach",
        description: "We prioritize client satisfaction with personalized services."
      },
      {
        title: "Cutting-Edge Technologies",
        description: "We use the latest advancements in AI, cloud computing, and automation."
      },
      {
        title: "End-to-End Services",
        description: "From strategy to execution, we provide comprehensive technology solutions."
      }
    ] ,
          img:img
  };


export {tieFeatures,chooseTie}  